<template>
  <div class="list-page">
    <crumbs title="服务信息管理" />
    <div class="list-page__querybar">
      <el-row>
        <el-col :span="22">
          <el-input
            v-model="queryCondition.name"
            clearable
            placeholder="服务名称"
          >
          </el-input>
        </el-col>
        <el-col class="fn-text-right" :span="2">
          <el-button
            @click="handleSearch"
            size="medium"
            type="success"
            icon="el-icon-search"
            round
            >查询</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="list-page__toolbar">
      <el-button type="success" icon="el-icon-circle-plus" @click="handleAdd"
        >添加
      </el-button>
      <el-button type="warning" icon="el-icon-delete" @click="handleBatchDelete"
        >删除</el-button
      >
    </div>
    <div
      class="list-page__table"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
    >
      <el-table
        :data="queryList"
        @selection-change="handleSelectionChange"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 200px; height: 100px"
              :src="scope.row.imgUrl"
              fit="contain"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="服务名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="发布时间" width="90" align="center">
          <template slot-scope="scope">
            <p>
              {{ scope.row.createTime.trim().split(/\s+/)[0] }}
            </p>
            <!-- <p>
                {{ scope.row.createTime.trim().split(/\s+/)[1] }}
              </p> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="warning" @click="handleLook(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fn-text-center mt-20">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryCondition.pageSize"
          :current-page.sync="queryCondition.pageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <add-expert-service
      v-if="serviceDialog"
      :dataId="serviceId"
      @close="serviceDialog = false"
      @complete="completeAdd"
    />
  </div>
</template>

<script>
export default {
  name: "expertServiceMessageList",
  data() {
    return {
      //查询条件
      queryCondition: {
        name: "",
        pageIndex: 1,
        pageSize: 15
      },
      total: 0,
      //是否处于loading状态
      isLoading: true,
      //查询结果
      queryList: [],
      //表格当前的选项（多选）
      multipleSelection: [],
      // 添加弹框
      serviceDialog: false,
      serviceId: ""
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    //出来参数
    processParams() {
      return this.queryCondition;
    },
    //获取列表
    loadList() {
      //初始化
      // this.queryList = [];
      this.isLoading = true;
      this.$api("expert", "getServiceList", this.processParams()).then(
        (res) => {
          this.isLoading = false;
          this.total = res.count;
          this.queryList = res.dataList;
        }
      );
    },
    //点击后查询
    handleSearch() {
      this.queryCondition.pageIndex = 1;
      this.loadList();
    },
    //表格相关
    //点击选中/取消选中表格选择项
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    // 点击添加
    handleAdd() {
      this.serviceId = "";
      this.serviceDialog = true;
    },
    //点击编辑
    handleLook(row) {
      const { id } = row;
      this.serviceId = id;
      this.serviceDialog = true;
    },
    //删除
    //点击批量删除
    handleBatchDelete() {
      const idList = this.multipleSelection.map((item) => item.id);
      if (idList.length) {
        this.$confirm("此操作将批量删除所选中的数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.loadDeleteData(idList);
          })
          .catch(() => {});
      }
    },
    //点击一条删除
    handleDelete(row) {
      this.$confirm("此操作将删除当前所选中的数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loadDeleteData([row.id]);
        })
        .catch(() => {});
    },
    loadDeleteData(idList) {
      // 测试防止删除
      const reserve = [
        "63601e56-2dca-4e7a-a510-a50689d18985",
        "9e318196-42e9-465a-9ce5-430545442268",
        "62841969-5938-44f2-bdde-f1a73bba770b",
        "5a10c39e-5a2e-42fe-ab57-be32c658718f",
        "f28fd10a-d4b0-4ede-8e9c-637302cc7b3f",
        "3ca75bc3-2ee2-4d5e-8bfd-fcc2f0ccba02"
      ];
      const bool = idList.some((item) => {
        return reserve.includes(item);
      });
      if (bool) {
        return this.$message.warning("不要删除已经创建的正式数据");
      }
      this.$api("expert", "batchServiceDelete", idList).then((res) => {
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.loadList();
        }
      });
    },
    //点击切换分页触发
    handleCurrentChange() {
      this.loadList();
    },
    // 完成添加
    completeAdd() {
      this.serviceDialog = false;
      this.loadList();
    }
  }
};
</script>

<style></style>
